import { Box } from "@mui/material";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";

// const ContentArea = ({ children, p, px = 2, py = 2.6, sx }) => {
const ContentArea = ({ children, p, px = 2, py = 2, sx, ...rest }) => {
  // const ContentArea = ({ children, p, px = 2.5, py = 1.5, sx }) => {
  // return (
  //   <FlxGrid
  //     width="320px"
  //     gap={5}
  //     sx={{ flexWrap: "wrap", px: p || px, py: p || py, ...sx }}
  //   >
  //     {children}
  //   </FlxGrid>
  // );
  return (
    <Box
      sx={{ flexWrap: "wrap", px: p || px, py: p || py, ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ContentArea;
